package ru.chm.gradereport.ui.screens.course

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.LinearProgressIndicator
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import ru.chm.gradereport.model.CourseAnalyticsDto
import ru.chm.gradereport.ui.components.AppCard
import ru.chm.gradereport.ui.components.CompactWidthBreakpoint
import ru.chm.gradereport.ui.components.GradientStatCard
import ru.chm.gradereport.ui.components.softClickable
import ru.chm.gradereport.ui.theme.BlueAccent
import ru.chm.gradereport.ui.theme.GradeTheme
import ru.chm.gradereport.ui.theme.GreenAccent
import ru.chm.gradereport.ui.theme.YellowAccent
import kotlin.math.roundToInt

@Composable
internal fun AnalyticsPanel(
    analytics: CourseAnalyticsDto,
    onOpenStudent: (String) -> Unit,
) {
    val colors = GradeTheme.colors
    val top = analytics.topStudents.firstOrNull()

    BoxWithConstraints(modifier = Modifier.fillMaxWidth()) {
        val narrow = maxWidth < CompactWidthBreakpoint
        val medium = maxWidth < 960.dp

        if (narrow) {
            Column(
                modifier = Modifier.fillMaxWidth(),
                verticalArrangement = Arrangement.spacedBy(12.dp),
            ) {
                GradientStatCard(
                    title = "Студентов",
                    value = "${analytics.totalStudents}",
                    colors = listOf(Color(0xFF0EA5E9), Color(0xFF22D3EE)),
                    modifier = Modifier.fillMaxWidth(),
                )
                GradientStatCard(
                    title = "Средняя посещаемость",
                    value = "${analytics.averageAttendancePercent.roundToInt()}%",
                    colors = listOf(Color(0xFF16A34A), Color(0xFF4ADE80)),
                    modifier = Modifier.fillMaxWidth(),
                )
                GradientStatCard(
                    title = "Средний % ДЗ",
                    value = "${analytics.averageHomeworkPercent.roundToInt()}%",
                    colors = listOf(Color(0xFF2563EB), Color(0xFF60A5FA)),
                    modifier = Modifier.fillMaxWidth(),
                )
                GradientStatCard(
                    title = "Лучший результат",
                    value = top?.fullName ?: "—",
                    subtitle = top?.let { "${it.scorePercent.roundToInt()}%" } ?: "",
                    colors = listOf(Color(0xFF0891B2), Color(0xFF22D3EE)),
                    modifier = Modifier.fillMaxWidth(),
                )
                TopStudentsCard(analytics = analytics, onOpenStudent = onOpenStudent)
                NeedsSupportCard(analytics = analytics, onOpenStudent = onOpenStudent)
            }
        } else if (medium) {
            Column(modifier = Modifier.fillMaxWidth()) {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(IntrinsicSize.Max),
                    horizontalArrangement = Arrangement.spacedBy(12.dp),
                ) {
                    GradientStatCard(
                        title = "Студентов",
                        value = "${analytics.totalStudents}",
                        colors = listOf(Color(0xFF0EA5E9), Color(0xFF22D3EE)),
                        modifier = Modifier.weight(1f).fillMaxHeight(),
                    )
                    GradientStatCard(
                        title = "Средняя посещаемость",
                        value = "${analytics.averageAttendancePercent.roundToInt()}%",
                        colors = listOf(Color(0xFF16A34A), Color(0xFF4ADE80)),
                        modifier = Modifier.weight(1f).fillMaxHeight(),
                    )
                }
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(top = 12.dp)
                        .height(IntrinsicSize.Max),
                    horizontalArrangement = Arrangement.spacedBy(12.dp),
                ) {
                    GradientStatCard(
                        title = "Средний % ДЗ",
                        value = "${analytics.averageHomeworkPercent.roundToInt()}%",
                        colors = listOf(Color(0xFF2563EB), Color(0xFF60A5FA)),
                        modifier = Modifier.weight(1f).fillMaxHeight(),
                    )
                    GradientStatCard(
                        title = "Лучший результат",
                        value = top?.fullName ?: "—",
                        subtitle = top?.let { "${it.scorePercent.roundToInt()}%" } ?: "",
                        colors = listOf(Color(0xFF0891B2), Color(0xFF22D3EE)),
                        modifier = Modifier.weight(1f).fillMaxHeight(),
                    )
                }
                Column(
                    modifier = Modifier.fillMaxWidth().padding(top = 16.dp),
                    verticalArrangement = Arrangement.spacedBy(12.dp),
                ) {
                    TopStudentsCard(analytics = analytics, onOpenStudent = onOpenStudent)
                    NeedsSupportCard(analytics = analytics, onOpenStudent = onOpenStudent)
                }
            }
        } else {
            Column(modifier = Modifier.fillMaxWidth()) {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(IntrinsicSize.Max),
                    horizontalArrangement = Arrangement.spacedBy(12.dp),
                ) {
                    GradientStatCard(
                        title = "Студентов",
                        value = "${analytics.totalStudents}",
                        colors = listOf(Color(0xFF0EA5E9), Color(0xFF22D3EE)),
                        modifier = Modifier.weight(1f).fillMaxHeight(),
                    )
                    GradientStatCard(
                        title = "Средняя посещаемость",
                        value = "${analytics.averageAttendancePercent.roundToInt()}%",
                        colors = listOf(Color(0xFF16A34A), Color(0xFF4ADE80)),
                        modifier = Modifier.weight(1f).fillMaxHeight(),
                    )
                    GradientStatCard(
                        title = "Средний % ДЗ",
                        value = "${analytics.averageHomeworkPercent.roundToInt()}%",
                        colors = listOf(Color(0xFF2563EB), Color(0xFF60A5FA)),
                        modifier = Modifier.weight(1f).fillMaxHeight(),
                    )
                    GradientStatCard(
                        title = "Лучший результат",
                        value = top?.fullName ?: "—",
                        subtitle = top?.let { "${it.scorePercent.roundToInt()}%" } ?: "",
                        colors = listOf(Color(0xFF0891B2), Color(0xFF22D3EE)),
                        modifier = Modifier.weight(1f).fillMaxHeight(),
                    )
                }

                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(top = 16.dp)
                        .height(IntrinsicSize.Max),
                    horizontalArrangement = Arrangement.spacedBy(12.dp),
                ) {
                    TopStudentsCard(
                        analytics = analytics,
                        onOpenStudent = onOpenStudent,
                        modifier = Modifier.weight(1f).fillMaxHeight(),
                    )
                    NeedsSupportCard(
                        analytics = analytics,
                        onOpenStudent = onOpenStudent,
                        modifier = Modifier.weight(1f).fillMaxHeight(),
                    )
                }
            }
        }
    }
}

@Composable
private fun TopStudentsCard(
    analytics: CourseAnalyticsDto,
    onOpenStudent: (String) -> Unit,
    modifier: Modifier = Modifier,
) {
    val colors = GradeTheme.colors
    AppCard(modifier = modifier.fillMaxWidth()) {
        Text("Топ студентов", color = colors.textPrimary, fontWeight = FontWeight.Bold)
        analytics.topStudents.forEach { item ->
            StudentRankRow(
                name = item.fullName,
                percent = item.scorePercent,
                nameColor = BlueAccent,
                percentColor = GreenAccent,
                barColor = GreenAccent,
                onClick = { onOpenStudent(item.studentId) },
            )
        }
    }
}

@Composable
private fun NeedsSupportCard(
    analytics: CourseAnalyticsDto,
    onOpenStudent: (String) -> Unit,
    modifier: Modifier = Modifier,
) {
    val colors = GradeTheme.colors
    AppCard(modifier = modifier.fillMaxWidth()) {
        Text("Нужна поддержка", color = colors.textPrimary, fontWeight = FontWeight.Bold)
        analytics.needsSupport.forEach { item ->
            StudentRankRow(
                name = item.fullName,
                percent = item.scorePercent,
                nameColor = YellowAccent,
                percentColor = Color(0xFFF87171),
                barColor = Color(0xFFF87171),
                onClick = { onOpenStudent(item.studentId) },
            )
        }
    }
}

@Composable
private fun StudentRankRow(
    name: String,
    percent: Double,
    nameColor: Color,
    percentColor: Color,
    barColor: Color,
    onClick: () -> Unit,
) {
    val colors = GradeTheme.colors
    Column(modifier = Modifier.fillMaxWidth().padding(top = 4.dp)) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .softClickable(
                    onClick = onClick,
                    highlight = nameColor,
                    shape = RoundedCornerShape(10.dp),
                    hoverAlpha = 0.16f,
                    pressAlpha = 0.26f,
                )
                .padding(horizontal = 8.dp, vertical = 8.dp),
            horizontalArrangement = Arrangement.SpaceBetween,
        ) {
            Text(
                name,
                color = nameColor,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
                modifier = Modifier.weight(1f).padding(end = 8.dp),
            )
            Text(
                "${percent.roundToInt()}%",
                color = percentColor,
                fontWeight = FontWeight.Bold,
            )
        }
        LinearProgressIndicator(
            progress = { (percent / 100.0).toFloat().coerceIn(0f, 1f) },
            modifier = Modifier.fillMaxWidth().padding(horizontal = 8.dp, vertical = 4.dp),
            color = barColor,
            trackColor = colors.border,
        )
    }
}
